<template>
	<div class="sale-after">
		<!-- 导航 -->
		<!-- <van-nav-bar
			class="van-nav"
		  title="售后订单查询"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/> -->
		<headerTemplate title="售后订单查询"></headerTemplate>

		<div class="max-content">
			<!-- 搜索div -->
			<div class="filter">
				<van-dropdown-menu>
					<van-dropdown-item title="订单号" ref="订单号">
						<van-field v-model="orderNum" label="订单号" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirmSearch">确认</van-button>
						</div>
					</van-dropdown-item>
					<van-dropdown-item title="退单号" ref="退单号">
						<van-field v-model="refundNum" label="退单号" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirmSearch">确认</van-button>
						</div>
					</van-dropdown-item>
					<van-dropdown-item title="买家会员名" ref="买家会员名">
						<van-field v-model="userName" label="买家会员名" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirmSearch">确认</van-button>
						</div>
					</van-dropdown-item>
					<van-dropdown-item v-model="typeVal" :options="typeOption" @change="onConfirmSearch" />
					<van-dropdown-item v-model="staVal" :options="staOption" @change="onConfirmSearch" />
					<van-dropdown-item title="下单时间" ref="下单时间">
						<van-cell title="选择日期区间" :value="date" @click="showDate = true" />
						<van-calendar v-model="showDate" type="range" :min-date="minDate" @confirm="timeConfirm" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirmSearch">确认</van-button>
						</div>
					</van-dropdown-item>
				</van-dropdown-menu>
			</div>
			<!-- 表格 -->
			<table border="1" class="table-order">
				<tr>
					<th width="80">会员名</th>
					<th width="120">订单号</th>
					<th width="120">退单号</th>
					<th width="80">售后类型</th>
					<th width="80">处理状态</th>
					<th width="130">操作</th>
				</tr>
				<tr v-for="(item, i) in afterList" :key="i">
					<td>{{item.buyer_name}}</td>
					<td>{{item.order_sn}}</td>
					<td>{{item.refund_sn}}</td>
					<td v-if="item.refund_type == 1">退款</td>
					<td v-if="item.refund_type == 2">退货</td>
					<td v-if="item.seller_state == 1">待审核</td>
					<td v-if="item.seller_state == 2">同意</td>
					<td v-if="item.seller_state == 3">同意</td>
					<td style="text-align: center; width: 100px;">
						<van-button type="info" size="mini" @click="goAfterInfo(item.refund_id)">详情</van-button>
						<van-button type="warning" size="mini" @click="showDialogPop()">审核</van-button>
						<van-dialog v-model="showDialog" show-cancel-button @confirm="sureCheck(item.refund_id)">
							<div style="display: flex; margin: 15px 0 0 15px">
								<span style="margin-right: 10px;">是否同意请求</span>
								<van-radio-group v-model="radio">
									<van-radio name="2" style="margin-bottom: 10px;">同意</van-radio>
									<van-radio name="3">不同意</van-radio>
								</van-radio-group>
							</div>
							<van-field v-model="oprateVal" label="处理内容" placeholder="请输入处理内容" />
						</van-dialog>
					</td>
				</tr>
			</table>
		</div>
		<van-pagination class="pagination" v-model="currentPage" :total-items="totalNum" :show-page-size="3"
			force-ellipses @change="changePage" />
	</div>
</template>

<script>
	import { getAfterList, editAfter } from '../../../api/sale'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'After',
		components: {
			headerTemplate
		},
		data() {
			return {
				// 订单号
				orderNum: '',
				// 退单号
				refundNum: '',
				// 买家名
				userName: '',
				// 申请类型
				typeVal: 0,
				// 处理状态
				staVal: 0,
				typeOption: [
					{ text: '全部', value: 0 },
					{ text: '退款申请', value: 1 },
					{ text: '退货申请', value: 2 }
				],
				staOption: [
					{ text: '全部', value: 0 },
					{ text: '待审核', value: 1 },
					{ text: '同意', value: 2 },
					{ text: '不同意', value: 3 },
				],
				// 展示日期选择
				showDate: false,
				// 日历显示最小日期
				minDate: new Date(2020, 0, 1),
				// 日期区间
				date: '',
				// 开始时间
				sDate: '',
				eDate: '',
				// 获取到的售后订单列表
				afterList: [],
				// 是否展示dialog
				showDialog: false,
				// 处理内容
				oprateVal: '',
				// radio
				radio: '2',
				// 当前页码
				currentPage: 1,
				// 总共的条数
				totalNum: 0
			}
		},
		methods: {
			// 返回上一页
			goBack() {
				this.$router.go(-1)
			},
			// 确认审核
			sureCheck(refundId) {
				editAfter(this.radio, this.oprateVal, refundId).then(res => {
					alert('处理成功')
				}).catch(error => {
					alert(error.message)
				})
			},
			// 改变切换页
			changePage() {
				this.getAfterList()
			},
			// 构造日期
			formatDate(date) {
				if ((date.getMonth() + 1) < 10 && date.getDate() < 10) {
					return `${date.getFullYear()}-0${date.getMonth() + 1}-0${date.getDate()}`;
				}
				if ((date.getMonth() + 1) < 10 && date.getDate() >= 10) {
					return `${date.getFullYear()}-0${date.getMonth() + 1}-${date.getDate()}`;
				}
				if ((date.getMonth() + 1) >= 10 && date.getDate() < 10) {
					return `${date.getFullYear()}-${date.getMonth() + 1}-0${date.getDate()}`;
				}
				return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			},
			// 确认选择的时间
			timeConfirm(date) {
				const [start, end] = date;
				this.showDate = false;
				this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
				this.sDate = `${this.formatDate(start)}`
				this.eDate = `${this.formatDate(end)}`
			},
			// 跳转到售后的详情页
			goAfterInfo(afterId) {
				this.$router.push({
					name: 'AfterInfo',
					params: {
						afterId: afterId
					}
				})
			},
			// 确认查询
			onConfirmSearch() {
				this.getAfterList()
				this.$refs['订单号'].toggle(false)
				this.$refs['退单号'].toggle(false)
				this.$refs['买家会员名'].toggle(false)
				this.$refs['下单时间'].toggle(false)
			},
			// 展示dialog
			showDialogPop() {
				this.showDialog = true
			},
			// 获取售后订单列表信息
			getAfterList() {
				getAfterList({
					order_sn: this.orderNum,
					refund_sn: this.refundNum,
					buyer_name: this.userName,
					add_time_from: this.sDate,
					add_time_to: this.eDate,
					refund_type: this.typeVal,
					state: this.staVal,
					page: this.currentPage
				}).then(res => {
					// 获取到的售后订单列表
					this.afterList = res.result.return_list
					// 总共的条数
					this.totalNum = res.result.total
				}).catch(error => {
					// alert('获取失败')
				})
			}
		},
		created() {
			this.getAfterList()
		}
	}
</script>

<style lang="scss" scoped>
	.sale-after {
		font-size: 14px;
		display: flex;
		flex-direction: column;

		.van-nav {
			z-index: 100;
			position: fixed;
			top: 0;
			width: 100%;
		}

		.max-content {
			z-index: 0;
			padding-bottom: 42px;
			height: calc(100% - 100px);
			overflow-y: scroll;
		}

		.pagination {
			position: fixed;
			bottom: 0;
			width: 100%;
		}
	}

	/* .sale-after   ::v-deep.van-nav-bar {
		background-color: #e93b3d;
		color: white;

		.van-icon-arrow-left,
		.van-nav-bar__text,
		.van-nav-bar__title {
			color: white;
		}
	} */

	.sale-after   ::v-deeptable {
		border: 1px solid #d8d8d8;
		display: -webkit-box;
		overflow-x: scroll;

		tr {

			th,
			td {
				text-align: center;
			}
		}
	}

	.table-order td {
		word-break: break-all;
	}
</style>